import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  CCard, CCardBody, CCardHeader, CButton, CSpinner, CAlert, CRow, CCol,
} from '@coreui/react';
import api from '../../services/api';
import { downloadPdf } from '../../services/financeDownload';

export default function InvoiceViewPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get(`/finance/invoices/${id}`)
      .then((r) => setData(r.data))
      .catch(() => setError('Invoice not found.'));
  }, [id]);

  if (error) return <CAlert color="danger">{error}</CAlert>;
  if (!data) return <div className="text-center py-5"><CSpinner color="success" /></div>;

  const { invoice, job, customer, amount_paid, balance_due } = data;

  return (
    <div className="invoice-print">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3 no-print">
        <CButton color="secondary" variant="outline" size="sm" component={Link} to="/finance/invoices">← Back</CButton>
        <span>
          <CButton color="success" variant="outline" size="sm" className="me-2" onClick={() => window.print()}>Print</CButton>
          <CButton color="success" size="sm" onClick={() => downloadPdf(`/finance/invoices/${id}/pdf`, `${invoice.invoice_no}.pdf`).catch(() => {})}>Download PDF</CButton>
        </span>
      </div>

      <CCard className="border shadow-sm" style={{ borderRadius: 8, maxWidth: 800, margin: '0 auto' }}>
        <CCardHeader className="bg-white py-4">
          <h4 className="mb-0">Tax invoice</h4>
          <div className="text-muted small mt-1">{invoice.invoice_no}</div>
        </CCardHeader>
        <CCardBody className="p-4">
          <CRow className="mb-4 small">
            <CCol md={6}>
              <div className="text-muted text-uppercase" style={{ fontSize: 11 }}>Bill to</div>
              <div className="fw-semibold">{customer?.nama || invoice.custid}</div>
              {customer?.telhp && <div>Tel: {customer.telhp}</div>}
              {customer?.email && <div>{customer.email}</div>}
            </CCol>
            <CCol md={6} className="mt-3 mt-md-0">
              <div className="text-muted text-uppercase" style={{ fontSize: 11 }}>Job</div>
              <div>Job ID: {job?.jid}</div>
              <div>Job code: {job?.jobcode || invoice.jobcode}</div>
              <div>Date: {String(invoice.created_at || '').slice(0, 10)}</div>
            </CCol>
          </CRow>

          <table className="table table-sm border-top">
            <thead>
              <tr className="text-muted small">
                <th>Description</th>
                <th className="text-end" style={{ width: 120 }}>Amount (RM)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ whiteSpace: 'pre-wrap' }}>{invoice.description || 'Service / repair'}</td>
                <td className="text-end">{Number(invoice.subtotal).toFixed(2)}</td>
              </tr>
              <tr>
                <td className="text-end">SST ({Number(invoice.sst_rate).toFixed(2)}%)</td>
                <td className="text-end">{Number(invoice.sst_amount).toFixed(2)}</td>
              </tr>
              {Number(invoice.discount) > 0 && (
                <tr className="text-success">
                  <td className="text-end">
                    Discount
                    {invoice.discount_note && (
                      <span className="text-muted ms-2 small">({invoice.discount_note})</span>
                    )}
                  </td>
                  <td className="text-end">− {Number(invoice.discount).toFixed(2)}</td>
                </tr>
              )}
              <tr className="fw-bold">
                <td className="text-end">Total</td>
                <td className="text-end">{Number(invoice.total).toFixed(2)}</td>
              </tr>
            </tbody>
          </table>

          <div className="mt-4 pt-3 border-top small">
            <div>Paid to date: <strong>RM {Number(amount_paid).toFixed(2)}</strong></div>
            <div>Outstanding: <strong className={balance_due > 0.01 ? 'text-warning' : 'text-success'}>RM {Number(balance_due).toFixed(2)}</strong></div>
          </div>
        </CCardBody>
      </CCard>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          .invoice-print .card { border: none !important; box-shadow: none !important; }
        }
      `}</style>
    </div>
  );
}
